// src/api.js
// central place for your API base URL
export const API = process.env.REACT_APP_API_URL;
